<template>
  <div class="layout">
    <layout-header />
    <keep-alive>
      <router-view :key="$route.fullPath" v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import LayoutHeader from './layout-header'

export default {
  name: 'Layout',
  components: { LayoutHeader }
}
</script>

<style lang="less">
.layout {
  width: 100%;
  height: 100%;
  background: #9aaeb2;
  display: flex;
  flex-direction: column;
}
</style>
